// import { force } from '../../../../utility/'
import { DEF_DATE, DEF_DATE_TIME, DEF_TIME } from '../../../utility/time'

import moment from 'moment-timezone'

// TODO: In the future should be retrieved via force method
export const TIMEZONE = moment.tz.guess()
// export const TIMEZONE = force('TIMEZONE')

export const SOQL_DATE_FORMAT = 'YYYY-MM-DD'
export const SOQL_TIME_FORMAT = moment.ISO_8601
export const DATEPICKER_FORMAT = 'YYYY-MM-DD'

// probably there is better way to check, that moment use AM/PM suffix in date.
export const is12h = () =>
  moment.tz(TIMEZONE).format('LT').length > 5

export const isAm = (date) =>
  moment.tz(date, SOQL_TIME_FORMAT, TIMEZONE).format('LT').includes('AM')

export const isValidSoqlDate = (value, isTime) => {
  let mtDate = isTime
    ? moment.tz(value, SOQL_TIME_FORMAT, true, TIMEZONE)
    : moment.utc(value, DATEPICKER_FORMAT, true)
  return mtDate.isValid()
}

export const formatDateToSoqlDate = (value, isTime) =>
  isTime ? moment.tz(value, DATEPICKER_FORMAT, true, TIMEZONE).format() : value

export const formatSoqlToDate = (value, isTime) =>
  isTime ? moment.tz(value, SOQL_TIME_FORMAT, true, TIMEZONE).format(DATEPICKER_FORMAT) : value

export const formatSoqlToMomentDate = (value) => {
  return moment.tz(value, SOQL_TIME_FORMAT, true, TIMEZONE)
}

export const formatMomentToSoqlDate = (value) =>
  value.tz(TIMEZONE).format()

export const formatMomentToHours = (value) =>
  value.tz(TIMEZONE).format('hh')

export const formatMomentToMinutes = (value) =>
  value.tz(TIMEZONE).format('mm')


export const formatTimestampToInputValue = (value, time, dateFormat, type) => {
  if (value) {
    if (type === 'TIME') {
      return moment.tz(value, TIMEZONE).format(dateFormat || DEF_TIME)
    }
    if (time) {
      return moment.tz(value, TIMEZONE).format(dateFormat || DEF_DATE_TIME)
    }
    return moment.tz(value, TIMEZONE).format(dateFormat || DEF_DATE)
  }
  return ''
}
